import './LoaderGlobal.scss';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';

interface Props {
    inline?: boolean;
    text?: string;
    opaque?: boolean;
}

function LoaderGlobal({ inline, text, opaque }: Props) {
    return (
        <div className={clsx('root', { inline, opaque })}>
            <div className="container">
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
            </div>
            {text && (
                <Typography variant="h4" color="primary" className="text">
                    {text}
                </Typography>
            )}
        </div>
    );
}

export default LoaderGlobal;